import * as types from '../../actionTypes';

const initialState = {
    medicineAddInfo: [],
    error: {},
    loading: false
}


export const medicineAddReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.MEDICINE_ADD_LOADING:
            return {
                ...state,
                loading: true
            }
        case types.MEDICINE_ADD_SUCCESS:
            console.log("action.payload",action.payload)
            return {
                ...state,
                medicineAddInfo: action.payload,
                loading: false,
                error: {}
            }
        case types.MEDICINE_ADD_FAIL:
            return{
                ...state,
                error: action.payload,
                loading: false,
            } 


        default:
            return state;
    }
}